import ErrorIcon from '@mui/icons-material/Error';
import { Typography, Box } from '@mui/material';

import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import {
  selectCohortBuilderItemViewed,
  markItemViewed,
  setModal,
} from '@verantos-dev/app-state-cohort-builder';
import { theme } from '@verantos-dev/shared-styles';
import {
  CohortBuilderItemChangeStatusLegacy,
  CohortBuilderModalLegacy,
  DerivedEventTypeLegacy,
  SimpleEventTypeLegacy,
  SubjectVariableTypeLegacy,
} from '@verantos-dev/types-cohorts';

export type CriterionProps = {
  id: string;
  name: string;
  type: SubjectVariableTypeLegacy | DerivedEventTypeLegacy | SimpleEventTypeLegacy | undefined;
  changeStatus?: CohortBuilderItemChangeStatusLegacy;
  isErrorIconShown?: boolean;
};

/**
 * Card that represents an individual criterion (subject variable)
 * Card content should have the criteria name and type
 */
export const Criterion = ({ id, name, type, changeStatus, isErrorIconShown }: CriterionProps) => {
  const dispatch = useAppDispatch();
  const hasBeenViewed = useAppSelector(selectCohortBuilderItemViewed(id));

  const isSimpleEvent = Object.values(SimpleEventTypeLegacy).includes(
    type as SimpleEventTypeLegacy
  );
  const isDerivedEvent = Object.values(DerivedEventTypeLegacy).includes(
    type as DerivedEventTypeLegacy
  );
  const isSubjectVariable = Object.values(SubjectVariableTypeLegacy).includes(
    type as SubjectVariableTypeLegacy
  );

  const handleListItemClick = () => {
    dispatch(markItemViewed(id));

    isSimpleEvent &&
      dispatch(
        setModal({
          id,
          modal: CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT,
        })
      );

    isDerivedEvent &&
      dispatch(
        setModal({
          id,
          modal: CohortBuilderModalLegacy.EDIT_DERIVED_EVENT,
        })
      );

    isSubjectVariable &&
      dispatch(
        setModal({
          id,
          modal: CohortBuilderModalLegacy.EDIT_SUBJECT_VARIABLE,
        })
      );
  };

  return (
    <Box
      key={id}
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        margin: '5px',
        '&:hover': {
          backgroundColor: `rgba(204,240,249, 0.608)`,
          cursor: 'pointer',
        },
        padding: theme.spacing(1),
        borderRadius: '8px',
        border: `1px solid ${theme.palette.divider}`,
      }}
      onClick={handleListItemClick}
    >
      {/* <CohortChangeStatusIcon changeStatus={changeStatus} hasBeenViewed={hasBeenViewed} /> */}
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body1">{name}</Typography>
        {isErrorIconShown ? <ErrorIcon color="error" fontSize="small" /> : null}
      </Box>
      <Typography variant="body1" sx={{ alignSelf: 'center' }}>
        Type: {type}
      </Typography>
    </Box>
  );
};
